import $ from 'jquery';
import { breakpoints } from 'js/config/breakpoints';

function changeFilterTabIndex() {
  $('.hero-seo-design__filter-mobile').children().attr('tabindex', $(document).width() > breakpoints.lg ? '-1' : '0');
}

window.addEventListener('resize', () => {
  changeFilterTabIndex();
});

window.addEventListener('load', () => {
  changeFilterTabIndex();

  const videoEls = window.document.querySelectorAll('.js-hero-seo-design-video');

  // Cloudflare videos use <video-js> + Video.js (initialized via common.js autoDetect).
  // Only run the native <video> init path for plain <video> elements with data-src.
  if (videoEls.length === 0) {
    return;
  }

  videoEls.forEach((videoEl) => {
    if (videoEl.tagName !== 'VIDEO-JS' && videoEl.dataset.src) {
      const sourceEl = window.document.createElement('source');

      sourceEl.setAttribute('src', `${videoEl.dataset.src}#t=0.1`);
      sourceEl.setAttribute('type', 'video/mp4');

      videoEl.appendChild(sourceEl);
      videoEl.load();

      videoEl.addEventListener('loadeddata', () => {
        window.scrollBy({ top: 1 });
      });
    }
  });
});

window.document.addEventListener('DOMContentLoaded', () => {
  const heroArrowBtnClass = '.js-hero-design-arrow';
  const heroMain = '.hero-seo-design';
  const heroArrowEl = document?.querySelector(heroArrowBtnClass);

  if (heroArrowEl !== null) {
    heroArrowEl.addEventListener('click', () => {
      const parent = heroArrowEl.closest(heroMain);
      const nextEl = parent.nextElementSibling;

      const offset = (window.innerWidth > breakpoints.sm) ? 98 : 50;
      const yCoordinate = nextEl.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: yCoordinate,
        behavior: 'smooth',
      });
    });
  }
});
